import { getJson } from './client';
import type { HealthResponse } from './types';

/** Een health-call die blijft hangen telt als fout, niet als "nog bezig":
 *  anders komt usePolling nooit in zijn foutpad en blijft de statustegel op
 *  de laatst bekende stand staan (#202). */
export const HEALTH_TIMEOUT_MS = 20_000;

export const fetchHealth = (): Promise<HealthResponse> =>
  new Promise<HealthResponse>((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new Error(`/api/health gaf binnen ${HEALTH_TIMEOUT_MS / 1000}s geen antwoord`)),
      HEALTH_TIMEOUT_MS,
    );
    getJson<HealthResponse>('/api/health').then(
      (v) => { clearTimeout(timer); resolve(v); },
      (e) => { clearTimeout(timer); reject(e); },
    );
  });
